import { BaseEntity } from './base-entity';

export interface Workspace extends BaseEntity {
  commune?: string;
  name: string;
  type: WorkspaceTypeKey;
}

export type WorkspaceTypeKey =
  | 'indicatorCategory'
  | 'dataLayerType'
  | 'poiDataLayerType'
  | 'bookmarkCategory'
  | 'topic';

export interface WorkspaceType {
  label: string;
  icon: string;
  value: WorkspaceTypeKey;
}

export const workspaceTypeIconMap: Record<WorkspaceTypeKey, string> = {
  indicatorCategory: 'fas fa-folder',
  dataLayerType: 'fas fa-map',
  poiDataLayerType: 'fas fa-location-dot',
  bookmarkCategory: 'fas fa-layer-group',
  topic: 'fas fa-book-open',
};
export const asWorkspaceTypeKey = (type: any): WorkspaceTypeKey => {
  return type;
};
